import { ComponentCountSummary, ComponentInstance } from '../types';

export interface IComponentLifecyclePlugin {
  name: string;

  initialize(tracker: any): void;
  onComponentCreated(component: ComponentInstance): void;
  onComponentDestroyed(component: ComponentInstance): void;
  onStatsUpdated(stats: ComponentCountSummary): void;
  dumpDebugInfo(): void;

  // Optional method for plugins that maintain state
  getStore?(): any;
}

export abstract class BaseComponentLifecyclePlugin implements IComponentLifecyclePlugin {
  name: string;
  protected tracker: any;

  constructor(name: string) {
    this.name = name;
  }

  initialize(tracker: any): void {
    this.tracker = tracker;
  }

  abstract onComponentCreated(component: ComponentInstance): void;
  abstract onComponentDestroyed(component: ComponentInstance): void;
  abstract onStatsUpdated(stats: ComponentCountSummary): void;

  dumpDebugInfo(): void {
    console.group(`[${this.name}] Debug Info`);
    console.log('Plugin:', this);
    console.groupEnd();
  }
}
